import { Expose } from "class-transformer";

export class CreateProjectHasTaskTypeDto {
  @Expose()
  projectId: string;

  @Expose()
  taskTypeId: string;
}
